//Page auto reload Testimonials
var engagebay_login_testimonials = [
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/ivan.jpeg",
        "content": "&#34;We were on the market for a solution that could help us bring email marketing and customer success together. EngageBay was easily the best in terms of number of features and price. Support is pretty good. Workflows and automations are top notch. Great support!&#34;",
        "name": "Ivan F",
        "role": "Head of Growth"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/tom.jpeg",
        "content": "&#34;We started out looking for an affordable CRM/Email Marketing System that didnâ€™t charge by # of Contacts. EngageBay was the most affordable of those we found. One of those products that gets better, not worse, the more you dig in into it. IT HAS EVERYTHING.&#34;",
        "name": "Tom W",
        "role": "Founder"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/ian.jpeg",
        "content": "&#34;EngageBay has better functionality, at a fraction of the investment. A pleasure to work with, support really wants to do anything they can, to help you out. Really proactive when we ask for any update. Very responsive. Really friendly team. Easy to use.&#34;",
        "name": "Ian N",
        "role": "Managing Director"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/steve.jpeg",
        "content": "&#34;It does everything the â€œbig nameâ€ companies do, at a fraction of the price. And the support staff is world-class. Very helpful, quick to respond 24/7. Our interactions have at least doubled since we started using EngageBay a few months ago.&#34;",
        "name": "Steve O",
        "role": "Owner"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/myriam.jpeg",
        "content": "&#34;I will recommend EngageBay to anyone looking for a great CRM and marketing tool! At EngageBay you get value for money. Managing all marketing in 1 place is great. I really appreciated the helpful, clear customer support via chat.&#34;",
        "name": "Myriam D",
        "role": "Chief Executive Officer"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/chris.jpeg",
        "content": "&#34;While itâ€™s not as full-featured as Hubspot, you get almost all of the same features at a much better price. I needed CRM and email marketing with workflows and drip campaigns which would have cost hundreds of dollars if I had stayed with Hubspot.&#34;",
        "name": "Chris K",
        "role": "Chief Executive Officer"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/jeremy.jpeg",
        "content": "&#34;Competitive on feature set, quality of support and price. Overall a good range of features and mostly intuitive user interface. The support quality and engagement is really appreciated especially when you hit a bottleneck and need someone to help.&#34;",
        "name": "Jeremy B",
        "role": "Designer"
    },
    {
        "image_url": "https://d2p078bqz5urf7.cloudfront.net/images/login/profile-images/william-henry.jpeg",
        "content": "&#34;This is a seriously powerful tool for any level of user. It is fast, and the automation feature being visual is seriously impressive. The speed you can get things running is amazing. No other CRM can honestly compete, for price and ease. EngageBay is a clear leader.&#34;",
        "name": "William Henry M",
        "role": "VP of Technology and Systems"
    }
];

$(function () {
    // Get local storage value
    var arrayIndex = localStorage.getItem("engagebay_login_testimonial_index");
    if (!arrayIndex || arrayIndex >= engagebay_login_testimonials.length) {
        arrayIndex = 0;
    }
    // Get array index JSON
    var json = engagebay_login_testimonials[arrayIndex];
    arrayIndex++;

    localStorage.setItem("engagebay_login_testimonial_index", arrayIndex);

    for (var k in json) {
        var $el = $("#tetimonial_" + k);
        if (k == "image_url")
            $el.attr("src", json[k]);
        else
            $el.html(json[k]);
    }
    $('.login-testimonial-sec').toggleClass("invisible");
});
////END Page auto reload Testimonials